module.exports = __webpack_public_path__ + "static/media/boomwriter_reversed.e86f4863.svg";